// extracted by mini-css-extract-plugin
export default {"container":"appDownload_container__41Sbb","logo":"appDownload_logo__Kcx7n","download-buttons":"appDownload_download-buttons__fGPf3","loader":"appDownload_loader__9A5tW"};